import {useState} from "react";
import {Menu} from "@mui/material";
import ArrowDropDown from "@mui/icons-material/ArrowDropDown";
import {SmallGreyButton} from "../../../../misc/SmallGreyButton";
import {LogisticsTab} from "./Logistics";
import {LogisticsView} from "./ViewButton";
import {RecalculateCogs} from "./RecalculateCogs";
import {BulkSource} from "./BulkSource";
import {BulkRelease} from "./BulkRelease";
import {BulkEditNeededBy} from "./BulkEditNeededBy";
import {BulkRemoveOrphaned} from "./BulkRemoveOrphaned";
import {BulkSendDuplicate} from "./BulkSendDuplicate";
import {BulkArchive} from "./BulkArchive";
import {useUser} from "../../../../misc/Permission";

export function LogisticsActions(props: {
    type: Exclude<LogisticsTab, "damaged" | "waste">;
    view: LogisticsView;
}) {
    const [anchorEl, setAnchorEl] = useState<HTMLElement|null>(null);
    const [open, setOpen] = useState(false);
    const close = () => setOpen(false);
    const user = useUser();

    return (
        <>
            <SmallGreyButton onClick={e => {
                setAnchorEl(e.currentTarget);
                setOpen(true);
            }} endIcon={<ArrowDropDown />}>
                Actions
            </SmallGreyButton>

            {/* keepMounted so an action's own menu survives this menu closing */}
            <Menu open={open} anchorEl={anchorEl} keepMounted onClose={close}>
                <BulkRelease type={props.type} view={props.view} anchorEl={anchorEl} onOpen={close} />
                <BulkSource type={props.type} anchorEl={anchorEl} onOpen={close} />
                <BulkEditNeededBy type={props.type} anchorEl={anchorEl} onOpen={close} />
                <BulkSendDuplicate type={props.type} anchorEl={anchorEl} onOpen={close} />
                <BulkRemoveOrphaned type={props.type} anchorEl={anchorEl} onOpen={close} />
                <RecalculateCogs type={props.type} anchorEl={anchorEl} onOpen={close} />
                {user?.role === "admin" && <BulkArchive type={props.type} anchorEl={anchorEl} onOpen={close} />}
            </Menu>
        </>
    )
}
